export enum BillStatuses {
  cancelled = 'Cancelled',
  paid = 'Paid',
  open = 'Open',
  overdue = 'Overdue',
}
